interface Config {
  apiUrl: string;
  appName: string;
}

// Function to determine the correct API URL based on environment
const getApiUrl = (): string => {
  // First check for environment variable
  if (process.env.REACT_APP_API_URL) {
    const apiUrl = process.env.REACT_APP_API_URL;
    console.log('Using API URL from environment variable:', apiUrl);
    return apiUrl;
  }

  console.log('No API URL found in environment, using default /api');
  return '/api';
};

const config: Config = {
  apiUrl: getApiUrl(),
  appName: 'Utilities CRM',
};

export default config;

// Export the getApiUrl function for use in other files
export { getApiUrl };
